import React, { useMemo } from 'react';
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom'


//REDUX DEL DETALLE DE LA INSCRIPCION
import * as actionsDetalleInscripcion from './_redux/DetalleInscripcion/DetalleInscripcionActions';

import { Card, CardHeader, CardHeaderToolbar, CardBody, } from "../../../../_metronic/_partials/controls";
import { Button } from 'react-bootstrap';

//COMPONONETE FORMULARIO PARA BUSCAR LA INSCRIPCION
import BuscarInscripcion from './Form/BuscarInscripcion';

//COMPONONETE QUE MUESTRAN TODOS LOS PASOS CON LOS DATOS DE LA INSCRIPCION
import Pasos from './Steps/Pasos';

//INFORMACION DE MESA DE AYUDA
import MesaAyuda from '../../../modules/Comun/Cards/MesaAyuda';


import objectPath from "object-path";
// LayoutContext
import { useHtmlClassService } from "../../../../_metronic/layout/_core/MetronicLayout";
// Import Layout components
import { Header } from "../../../../_metronic/layout/components/header/Header";
import { HeaderMobile } from "../../../../_metronic/layout/components/header-mobile/HeaderMobile";
// import {Aside} from "./aside/Aside";
import { Footer } from "../../../../_metronic/layout/components/footer/Footer";
//import {LayoutInit} from "./LayoutInit";
//import {SubHeader} from "../../../../_metronic/layout/components/subheader/SubHeader";
// import {QuickPanel} from "./extras/offcanvas/QuickPanel";
// import {QuickUser} from "./extras/offcanvas/QuickUser";
// import {ScrollTop} from "./extras/ScrollTop";
// import {StickyToolbar} from "./extras/StickyToolbar";


const DetalleInscripcion = () => {
    const history = useHistory();
    //DISPATCH
    const dispatch = useDispatch();

    const { detalleInscripcionInformacion } = useSelector(
        state => state.detalleInscripcion,
        shallowEqual
    );

    function reiniciarDatos() {
        dispatch(actionsDetalleInscripcion.stateLimpiar());
    };

    const uiService = useHtmlClassService();
    // Layout settings (cssClasses/cssAttributes)
    const layoutProps = useMemo(() => {
        return {
            layoutConfig: uiService.config,
            selfLayout: objectPath.get(uiService.config, "self.layout"),
            asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
            subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
            stickyToolbarDisplay: objectPath.get(uiService.config, "extras.toolbar.display"),
            desktopHeaderDisplay: objectPath.get(
                uiService.config,
                "header.self.fixed.desktop"
            ),
            contentCssClasses: uiService.getClasses("content", true),
            contentContainerClasses: uiService.getClasses("content_container", true),
            contentExtended: objectPath.get(uiService.config, "content.extended")
        };
    }, [uiService]);

    return (
        <>
            {/*begin::Main*/}
            <HeaderMobile sinUser={true} />
            <div className="d-flex flex-column flex-root">
                {/*begin::Page*/}
                <div className="d-flex flex-row flex-column-fluid page">
                    {/* {layoutProps.asideDisplay && (<Aside/>)} */}
                    {/*begin::Wrapper*/}
                    <div className="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
                        <Header sinUser={true} />
                        {/*begin::Content*/}
                        <div id="kt_content" className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}>
                            {/* {layoutProps.subheaderDisplay && <SubHeader/>} */}
                            {/*begin::Entry*/}
                            {!layoutProps.contentExtended && (
                                <div className="d-flex flex-column-fluid">
                                    {/*begin::Container*/}
                                    <div className={layoutProps.contentContainerClasses}>

                                        <Card>
                                            <CardHeader title={`${detalleInscripcionInformacion ? "Información del Aspirante" : "Inscripción Online"}`}>
                                                <CardHeaderToolbar>
                                                    {detalleInscripcionInformacion ?
                                                        <Button size="sm" variant="outline-success" className="p-1 pl-5 pr-5"
                                                            onClick={() => reiniciarDatos()}
                                                        > Atras </Button>
                                                        :
                                                        <Button size="sm" variant="outline-success" className="p-1 pl-5 pr-5"
                                                            onClick={() => { reiniciarDatos(); history.push("/noticias"); }}
                                                        > Inicio </Button>
                                                    }
                                                </CardHeaderToolbar>
                                            </CardHeader>
                                            <CardBody>
                                                {detalleInscripcionInformacion ?
                                                    <Pasos data={detalleInscripcionInformacion} />
                                                    :
                                                    <BuscarInscripcion />
                                                }
                                            </CardBody>
                                        </Card>
                                        <MesaAyuda />

                                    </div>
                                    {/*end::Container*/}
                                </div>
                            )}
                            {/*end::Entry*/}
                        </div>
                        {/*end::Content*/}
                        <Footer />
                    </div>
                    {/*end::Wrapper*/}
                </div>
                {/*end::Page*/}
            </div>
        </>
    )
}

export default DetalleInscripcion;